import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const EnterFullscreenIcon = ({
  color = "currentColor",
  ...svgProps
}: Props): React.JSX.Element => {
  return (
    <SVG
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g transform="translate(-14 -14)">
        <path d="M22 35h-7v-7m13-13h7v7m0 6v7h-7M15 22v-7h7" />
      </g>
    </SVG>
  );
};
